import { AiOutlinePlusCircle } from 'react-icons/ai';

import ContractSection from './ContractSection';
import { nameAndPriceColumns } from './helper';

const Additional = ({ services = [] }) => {
  const additionalServices = services.filter((service) => service.serviceType === 'additional');

  if (!additionalServices.length) return null;

  return (
    <ContractSection
      icon={AiOutlinePlusCircle}
      title="Нэмэлт үйлчилгээ"
      description="Гэрээнд тусгагдсан бусад үйлчилгээний төлбөр."
      columns={nameAndPriceColumns}
      dataSource={additionalServices}
    />
  );
};

export default Additional;
